import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PositionedTooltips from './PositionedTooltips';
import ClientProvider from './client';
export default createDemo(import.meta.url, PositionedTooltips, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tooltips/demos/positioned/PositionedTooltips.tsx",
    "fileName": "PositionedTooltips.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\n\nexport default function PositionedTooltips() {\n  return (\n    <Box sx={{ width: 500 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Tooltip describeChild title=\"Add\" placement=\"top-start\">\n          <Button>top-start</Button>\n        </Tooltip>\n        <Tooltip describeChild title=\"Add\" placement=\"top\">\n          <Button>top</Button>\n        </Tooltip>\n        <Tooltip describeChild title=\"Add\" placement=\"top-end\">\n          <Button>top-end</Button>\n        </Tooltip>\n      </Stack>\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-start' }}>\n          <Tooltip describeChild title=\"Add\" placement=\"left-start\">\n            <Button>left-start</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"left\">\n            <Button>left</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"left-end\">\n            <Button>left-end</Button>\n          </Tooltip>\n        </Stack>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-end' }}>\n          <Tooltip describeChild title=\"Add\" placement=\"right-start\">\n            <Button>right-start</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"right\">\n            <Button>right</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"right-end\">\n            <Button>right-end</Button>\n          </Tooltip>\n        </Stack>\n      </Box>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Tooltip title=\"Add\" placement=\"bottom-start\">\n          <Button>bottom-start</Button>\n        </Tooltip>\n        <Tooltip title=\"Add\" placement=\"bottom\">\n          <Button>bottom</Button>\n        </Tooltip>\n        <Tooltip title=\"Add\" placement=\"bottom-end\">\n          <Button>bottom-end</Button>\n        </Tooltip>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 57,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Button from '@mui/material/Button';\nimport Tooltip from '@mui/material/Tooltip';\n\nexport default function PositionedTooltips() {\n  return (\n    <Box sx={{ width: 500 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Tooltip describeChild title=\"Add\" placement=\"top-start\">\n          <Button>top-start</Button>\n        </Tooltip>\n        <Tooltip describeChild title=\"Add\" placement=\"top\">\n          <Button>top</Button>\n        </Tooltip>\n        <Tooltip describeChild title=\"Add\" placement=\"top-end\">\n          <Button>top-end</Button>\n        </Tooltip>\n      </Stack>\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-start' }}>\n          <Tooltip describeChild title=\"Add\" placement=\"left-start\">\n            <Button>left-start</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"left\">\n            <Button>left</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"left-end\">\n            <Button>left-end</Button>\n          </Tooltip>\n        </Stack>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-end' }}>\n          <Tooltip describeChild title=\"Add\" placement=\"right-start\">\n            <Button>right-start</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"right\">\n            <Button>right</Button>\n          </Tooltip>\n          <Tooltip describeChild title=\"Add\" placement=\"right-end\">\n            <Button>right-end</Button>\n          </Tooltip>\n        </Stack>\n      </Box>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Tooltip title=\"Add\" placement=\"bottom-start\">\n          <Button>bottom-start</Button>\n        </Tooltip>\n        <Tooltip title=\"Add\" placement=\"bottom\">\n          <Button>bottom</Button>\n        </Tooltip>\n        <Tooltip title=\"Add\" placement=\"bottom-end\">\n          <Button>bottom-end</Button>\n        </Tooltip>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 57,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Button",
      "@mui/material/Tooltip"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
